import { ResponsiveType } from '@sport1/react-elements/core/types'
import { ResponsiveInsets } from '@sport1/react-elements/core/styles/utils/transformProps/types'
import { spacings } from '../../DesignSystem/spacings'
import { ResponsiveFontVariants } from '../../Theme/Fonts/FontTypes'
import { SquareTeaserSizes, ResponsiveSquareTeaserSizes } from './types'

interface UseGetSquareTeaserStylesReturnValue {
    height: ResponsiveType<number>
    width: ResponsiveType<number>
    teaserInfoIconSize: ResponsiveType<number>
    iconMarginRight: ResponsiveInsets
    headlineFontVariant: ResponsiveFontVariants
    infoFontVariant: ResponsiveFontVariants
}

type SquareTeaserStyles = {
    [key in SquareTeaserSizes]: UseGetSquareTeaserStylesReturnValue
}

export const useGetSquareTeaserStyles = (
    size: ResponsiveSquareTeaserSizes
): UseGetSquareTeaserStylesReturnValue => {
    const squareTeaserStyles: SquareTeaserStyles = {
        S: {
            height: 141,
            width: 141,
            teaserInfoIconSize: 12,
            iconMarginRight: spacings['spacing-none'],
            headlineFontVariant: 'Body-M',
            infoFontVariant: 'Label-M',
        },
        M: {
            height: 185,
            width: 185,
            teaserInfoIconSize: 12,
            iconMarginRight: spacings['spacing-1'],
            headlineFontVariant: 'Title-S',
            infoFontVariant: 'Label-L',
        },
        L: {
            height: 238,
            width: 238,
            teaserInfoIconSize: 16,
            iconMarginRight: spacings['spacing-2'],
            headlineFontVariant: 'Title-L',
            infoFontVariant: 'Body-M',
        },
    }
    const getStyle = (sizeKey: SquareTeaserSizes) => ({
        ...squareTeaserStyles[sizeKey],
    })

    if (Array.isArray(size)) {
        const styles = size.map(getStyle)
        return {
            height: styles.map(s => s.height) as ResponsiveType<number>,
            width: styles.map(s => s.width) as ResponsiveType<number>,
            teaserInfoIconSize: styles.map(s => s.teaserInfoIconSize) as ResponsiveType<number>,
            iconMarginRight: styles.map(s => s.iconMarginRight) as ResponsiveInsets,
            headlineFontVariant: styles.map(s => s.headlineFontVariant) as ResponsiveFontVariants,
            infoFontVariant: styles.map(s => s.infoFontVariant) as ResponsiveFontVariants,
        }
    }

    const singleStyle = getStyle(size)
    return {
        height: singleStyle.height,
        width: singleStyle.width,
        teaserInfoIconSize: singleStyle.teaserInfoIconSize,
        iconMarginRight: singleStyle.iconMarginRight,
        headlineFontVariant: singleStyle.headlineFontVariant,
        infoFontVariant: singleStyle.infoFontVariant,
    }
}
